import { StatusBar, StyleSheet } from "react-native";

const styles = StyleSheet.create({
    mainContainer: {
        flex: 1,
        paddingTop: StatusBar.currentHeight,
        backgroundColor: "#fff",
        margin: 'auto'
    },
    header: {
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 30,
        width: "70%",
        marginLeft: 40,
        marginRight: 'auto',
        marginBottom: 30
    },
    headerTitle: {
        fontFamily: 'Montserrat_400Regular',
        fontSize: 30,
        marginLeft: 20,
        width: "80%"
    },
    sections: {
        justifyContent: 'center',
        width: "80%",
        marginLeft: 40,
        marginRight: 'auto',
        // alignItems: 'center'
    },
    section: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: "#f5f5f5",
        height: 80,
        borderRadius: 25,
        marginBottom: 20 
    },
    sectionIconView: {
        justifyContent: 'center',
        alignItems: 'center',
        width: 80,
        height: 80,
        backgroundColor: '#F0784A',
        borderRadius: 25 
    },
    sectionTitle: {
        marginLeft: 15,
        fontFamily: 'Montserrat_400Regular',
        fontSize: 20,
        width: '60%'
    }
});

export default styles;